export default {
  // errors
  ERROR_FETCHING_ADMIN_LEADS: "There was an error getting admin leads list",
};
